
<template>
  <div id="serie-payment-result" v-loading="dataLoading">
    <el-dialog v-dialogDragOnly :close-on-click-modal="false" custom-class="lg-dialog serie-payment-result" append-to-body :visible="visible" :before-close="hideAdd" :title="$t(title)">
      <!-- 支付结果图标 -->
      <div class="lay-result" :class="resultStyle.layClass">
        <i class="icon" :class="resultStyle.iconClass"></i>
        <span class="text">{{ message }}</span>
      </div>
      <!-- 支付流水信息 -->
      <div class="lay-payment">
        <h4 class="title">{{$t('portal.zhi-fu-xin-xi')}}</h4>
        <div class="pay_list_contain">
          <div v-for="(item, index) in payMessage.data" :key="index" class="pay_list_box">
            <p class="detail_p p_1">
              <span class="detail_s">{{$t('portal.liu-shui-hao')}}{{item.sn||'--'}} </span>
              <span class="detail_s">{{$t('portal.ding-dan-hao')}}{{item.order_no||'--'}} </span>
            </p>
            <p class="detail_p">
              <span class="detail_s">{{$t('portal.shou-kuan-hu-ming')}}{{item.collection_name||'--'}} </span>
              <span class="detail_s">{{$t('portal.shou-kuan-zhang-hao')}}{{item.collection_account_number||'--'}} </span>
              <span class="detail_s">{{$t('portal.fu-kuan-jine')}}<span class="amount">{{formatMoney(item.amount)}}</span> </span>
              <span class="detail_s">{{$t('portal.zhi-fu-jie-guo')}}<span :class="item.is_success?'success':'failure'">{{item.is_success ? $t('portal.cheng-gong') : $t('portal.shi-bai')}}</span> </span>
            </p>
          </div>
        </div>
        <div class="pay_message">
          <p class="detail_p">
            <span class="detail_s">{{$t('portal.fu-kuan-hu-ming')}}{{payMessage.data[0].payment_name||'--'}} </span>
            <span class="detail_s">{{$t('portal.fu-kuan-zhang-hao')}}{{payMessage.data[0].payment_account_name||'--'}} </span>
            <span class="detail_s">{{$t('portal.jiao-yi-shi-jian')}}{{payMessage.data[0].captured_at | filterTimeToFormatTime('YY/MM/DD-HH:mm:ss')}} </span>
          </p>
          <p>{{$t('common.remark')}}{{payMessage.note}}</p>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="lay-footer" v-if="showFooter">
        <el-button size="medium" @click="toOrderList">{{$t(colseText)}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { icFilters } from '~/common/plugins/ic-utils.js';
export default {
  name: 'SeriePaymentResult',
  props: {
    colseText: {
      type: String,
      default: 'portal.cha-kan-ding-dan'
    },
    title: {
      type: String,
      default: 'portal.zhi-fu-shou-yin-tai'
    },
    visible: {
      type: Boolean,
      default: false
    },
    payMessage: {
      //支付结果
      type: Object,
      default: () => ({})
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dataLoading: false
    };
  },
  computed: {
    isSuccess() {
      return this.payMessage.status === '100' || this.payMessage.status === '200';
    },
    message() {
      if (this.payMessage.status === '100') {
        return this.$t('portal.zhi-fu-cheng-gong');
      }
      if (this.payMessage.status === '200') {
        return this.$t('portal.bu-fen-zhi-fu-cheng-gong');
      }
      if (this.payMessage.status === '400') {
        return this.$t('portal.zhi-fu-shi-bai');
      }
    },
    // 成功或者失败的样式和文案在这里处理
    resultStyle() {
      const isSuccess = this.isSuccess;
      return {
        layClass: isSuccess ? 'success' : 'error',
        iconClass: isSuccess ? 'el-icon-success' : 'el-icon-error'
      };
    }
  },
  watch: {},
  created() {},
  methods: {
    toOrderList() {
      //跳转到采购跟单的列表页面中
      //window.open('/forward/order/purchase_bill','_blank');
      if (this.payMessage.type === 'platform') {
        window.open(`/store/order/purchase_bill`, '_black');
        return;
      }
      if (this.payMessage.type === 'offline' && this.payMessage.match_type === 'S') {
        window.open(`/store/order/sale_bill`, '_black');
        return;
      }
      if (this.payMessage.type === 'offline' && this.payMessage.match_type === 'P') {
        window.open(`/store/order/purchase_bill`, '_black');
        return;
      }
    },
    // 金额格式处理
    formatMoney(value = 0, noSymbol = false) {
      if (value === 0) {
        return '0';
      }
      return icFilters.formatMoney(value, null, 4, null, noSymbol, null, '2');
    },
    hideAdd() {
      let m = this.$store.state.pay.payRefresh;
      this.$store.commit('pay/set_payRefresh', ++m);
      this.$emit('hide');
    }
  }
};
</script>

<style lang="less">
.serie-payment-result {
  overflow: auto;
  .el-loading-mask {
    border: none;
  }
  .lay-result,
  .lay-payment {
    padding: 12px 20px;
    border-bottom: 1px solid #efefef;
    .title {
      margin-bottom: 10px;
      font-size: 15px;
      line-height: 28px;
      color: #3f3f3f;
    }
    .pay_list_contain {
      height: 150px;
      overflow-y: auto;
      .pay_list_box {
        padding: 10px 0;
        margin-bottom: 10px;
        border-bottom: 1px dashed;
        .detail_p {
          display: flex;
          .detail_s {
            flex: 1;
            .amount {
              color: #f56c6c;
            }
            .success {
              color: #20cb1d;
            }
            .failure {
              color: #f56c6c;
            }
          }
        }
        .detail_p.p_1 {
          width: 50%;
          margin-bottom: 10px;
        }
      }
    }
    .pay_message {
      margin-top: 20px;
      .detail_p {
        display: flex;
        margin-bottom: 10px;
        .detail_s {
          flex: 1;
        }
      }
    }
  }
  .lay-result {
    display: flex;
    align-items: center;
    justify-content: center;
    &.success {
      height: 130px;
    }
    &.error {
      height: 130px; //35vh
    }
    .icon {
      font-size: 50px;
      margin-right: 10px;
    }
    .el-icon-success {
      color: #20cb1d;
    }
    .el-icon-error {
      color: red;
    }
    .text {
      font-size: 20px;
      font-weight: 700;
    }
  }
  .lay-footer {
    padding: 25px 0 20px;
    text-align: center;
    .el-button {
      width: 126px;
      margin: 15px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
